import { render, staticRenderFns } from "./DecompositionDetailsQuickActions.vue?vue&type=template&id=6a40b34c"
import script from "./DecompositionDetailsQuickActions.vue?vue&type=script&lang=js"
export * from "./DecompositionDetailsQuickActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports